import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';

const WidgetErrorState = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 h-full p-6 text-center bg-red-50 dark:bg-red-950/30 rounded-lg">
      <p className="m-0 text-base text-red-700 dark:text-red-300 leading-snug">{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="px-3 py-1.5 text-sm font-medium rounded border border-edge-strong bg-surface text-content-secondary hover:bg-surface-hover transition-colors cursor-pointer"
      >
        {WIDGET_GRID_COPY.actions.retry}
      </button>
    </div>
  );
};

WidgetErrorState.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
};

WidgetErrorState.defaultProps = {
  message: WIDGET_GRID_COPY.errors.generic,
};

export default WidgetErrorState;
